// src/components/Analytics/RastreioDeRota.js
//
// Dispara um page_view a cada troca de rota do react-router.
// Precisa ficar DENTRO do <Router>, senao useLocation lanca erro.
// Nao renderiza nada.

import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { iniciarAnalytics, paginaVista } from '../../analytics'

const RastreioDeRota = () => {
  const local = useLocation()

  useEffect(() => {
    iniciarAnalytics()
  }, [])

  useEffect(() => {
    // o title so e atualizado depois da pintura da rota nova
    const t = setTimeout(() => paginaVista(local.pathname + local.search), 0)
    return () => clearTimeout(t)
  }, [local.pathname, local.search])

  return null
}

export default RastreioDeRota
